module.exports = __webpack_public_path__ + "img/shenzaang.a9965aa8.png";